import React, { useContext } from 'react';
import { css } from '@emotion/react';
import t from 'react-translate';
import { useMediaQuery } from 'react-responsive';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import { getAiRolePlay } from 'redux/selectors/timeline';
import { openConfirmationDialog } from 'redux/actions/confirmation-dialogs';

import { Button } from 'react-bootstrap';
import NvIcon from 'shared/components/nv-icon';
import { screenXsMax } from 'styles/global_defaults/media-queries';
import GradientAiIcon from '../../left-panel/novo-ai/components/shared/gradient-ai-icon';
import AiConversationContext from './context';

const styles = css`
  min-height: 70px;
`;

const ConversationModalHeader = () => {
  const dispatch = useDispatch();
  const {
    isConversationStarted,
    setIsConversationStarted,
    setShowScenarioDetails,
    aiRolePlayId,
    handleExitChat,
  } = useContext(AiConversationContext);

  const aiRolePlay = useSelector((state) => getAiRolePlay(state, aiRolePlayId));
  const { title } = aiRolePlay || {};

  const isMobile = useMediaQuery({
    query: `(max-width: ${screenXsMax}px)`,
  });

  const handleStartOver = () => {
    dispatch(openConfirmationDialog({
      title: t.FORM.ARE_YOU_SURE(),
      bodyText: t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.START_OVER_CONFIRMATION.MESSAGE(),
      confirmText: t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.START_OVER_CONFIRMATION.CONFIRM(),
      cancelText: t.FORM.CANCEL(),
      onConfirm: () => {
        setIsConversationStarted(false);
        setShowScenarioDetails(true);
      },
    }));
  };

  return (
    <div css={styles} className={`border-bottom d-flex ${isMobile ? 'px-4' : 'px-6'}`}>
      <GradientAiIcon icon='gen-ai' size='smallest' className='pr-2 pt-4' />
      <div className={`d-flex pt-4 ${isMobile ? 'flex-column' : ''}`}>
        <p className={`mb-0 text-regular bold ${!isMobile ? 'mr-1' : ''}`}>
          {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.ROLE_PLAY()}
        </p>
        <p className='mb-0'>{title}</p>
      </div>
      {isConversationStarted && (
      <div className='ml-auto d-flex pt-3 pb-4'>
        <Button
          className='bg-transparent shadow-none border-0 text-gray-1 d-flex px-0'
          onClick={handleStartOver}
          aria-label={t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.START_OVER()}
        >
          <NvIcon
            icon='refresh'
            size='small'
            className='d-flex align-items-center'
          />
          {!isMobile && (
            <p className='mb-0 ml-2'>
              {t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.START_OVER()}
            </p>
          )}
        </Button>
        <Button
          variant='danger'
          className={isMobile ? 'ml-4' : 'ml-5'}
          onClick={() => handleExitChat()}
          aria-label={t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.EXIT_CHAT()}
        >
          {isMobile
            ? t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.EXIT()
            : t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.EXIT_CHAT()}
        </Button>
      </div>
      )}
    </div>
  );
};

export default ConversationModalHeader;
